import { render } from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=template&id=b35f9d16&scoped=true"
import script from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellSettingsSummaryItemsV3.vue?vue&type=style&index=0&id=b35f9d16&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b35f9d16"]])

export default __exports__